export default function paddUrl(url) {
	let link = url

	if(link.substr(-1) !== '/'){
		link += '/'
	}

	return link
}